import classNames from 'styles/utils/classNames';

interface Props {
  className?: string;
}

/** The 3D success disc (Figma "Big picture / Success"): grass-textured disc with a
 *  white check and the floor shadow, laid out with the design's insets. */
export default function Success3dIllustration({ className }: Props) {
  return (
    <div className={classNames('relative', className)} aria-hidden>
      <img
        src="/images/app/success-3d/shadow.svg"
        alt=""
        className="absolute inset-[78.33%_0_3.33%_0] h-auto w-full"
      />
      <img
        src="/images/app/success-3d/disc.png"
        alt=""
        className="absolute inset-[7.5%_20%_32.5%_20%] h-[60%] w-[60%]"
      />
      <img
        src="/images/app/success-3d/check.svg"
        alt=""
        className="absolute inset-[25.6%_33.33%_50.6%_33.33%] h-[23.8%] w-[33.34%]"
      />
    </div>
  );
}
